import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "22",
  viewBox: "0 0 21 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#8E97A1",
  "fill-rule": "nonzero",
  d: "M20 21h1l-1 1v-1zm0 0v-7h1v8H0v-8h1v7h19zM1 21v1l-1-1h1zm0 0v1l-1-1h1zm0 0h19v-7h1v8H0v-8h1v7zm9-5.707V0h1v15.657L15.657 11l.707.707-5.657 5.657-.025-.025-.025.025-.364-.364H10v-.293l-5-5L5.707 11 10 15.293zM20 21h1l-1 1v-1z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}